/** Configurable via NEXT_PUBLIC_TOKEN_SERVICE_URL. Falls back to NEXT_PUBLIC_TOKEN_FILTER_URL for backward compat. */
const raw =
  process.env.NEXT_PUBLIC_TOKEN_SERVICE_URL || process.env.NEXT_PUBLIC_TOKEN_FILTER_URL || "https://tokens.b3.fun";
export const TOKEN_SERVICE_URL = raw.endsWith("/") ? raw.slice(0, -1) : raw;
